import { queryModelDetails } from "./service";

// 获取模型信息（如果模型被删除，则返回undefined）
export async function getModelListLatest(models: { id: number }[]) {
  return await Promise.all(
    models.map(async (item) => {
      try {
        const { data } = await queryModelDetails({ id: item.id });
        // 模型已经被删除
        if (data.deleteStatus === 1) return undefined;
        // 官方模型已下线
        if (data.status === 0) return undefined;

        return data;
      } catch (error) {
        return undefined;
      }
    })
  );
}

export async function getModelLatestInfo(modelId: number) {
  try {
    const { data } = await queryModelDetails({ id: modelId });

    // 模型已经被删除
    if (data.deleteStatus === 1) {
      return { deleted: true, modelInfo: data };
    }

    // 官方模型已下线
    if (data.status === 0) {
      return { deleted: true, modelInfo: data };
    }

    return { deleted: false, modelInfo: data };
  } catch (error) {
    return { deleted: true, modelInfo: null };
  }
}

// 风格模型标签
export const loraLabelMap: Record<string, string> = {
  "1": "通用",
  "2": "造型",
  "3": "画风"
};

// 获取风格模型后缀
export function getLoraSlicerText(value?: number | null) {
  if (typeof value === "number" && [2, 3].includes(value)) {
    const label = loraLabelMap[value.toString()];
    return `-${label}分离模型`;
  }
}
